import { DESIGN_SYSTEM_JS } from '../config';

export function loadDesignSystemScript() {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${DESIGN_SYSTEM_JS}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = DESIGN_SYSTEM_JS;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`Failed to load script: ${DESIGN_SYSTEM_JS}`));
    document.head.appendChild(script);
  });
}
